import type { DurationUnit } from 'date-fns';
import { format } from 'date-fns/format';
import { enGB, nb } from 'date-fns/locale';
import type { LanguageCode } from '~/Partials/Locale/Locale';

export const getToday = () => new Date();

export const mapToDateLocale = (lang: LanguageCode) => (lang === 'no' ? nb : enGB);

const durationUnits: DurationUnit[] = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'] as const;

export const isDurationUnit = (unit: string): unit is DurationUnit => durationUnits.includes(unit as DurationUnit);

export const formatDateShort = (date: Date, currentLanguage: LanguageCode) =>
    format(date, 'P', {
        locale: mapToDateLocale(currentLanguage),
    });

export const formatDateShortWithTime = (date: Date, currentLanguage: LanguageCode) =>
    format(date, 'Pp', {
        locale: mapToDateLocale(currentLanguage),
    });

export const formatDateLong = (date: Date, currentLanguage: LanguageCode) =>
    format(date, 'PPP', {
        locale: mapToDateLocale(currentLanguage),
    });

export const formatDateLongWithTime = (date: Date, currentLanguage: LanguageCode) =>
    format(date, 'PPPp', {
        locale: mapToDateLocale(currentLanguage),
    });

export const formatDateDayMonth = (date: Date, currentLanguage: LanguageCode) =>
    format(date, 'do MMMM', {
        locale: mapToDateLocale(currentLanguage),
    });

export const formatDayName = (date: Date, currentLanguage: LanguageCode) =>
    format(date, 'EEEE', {
        locale: mapToDateLocale(currentLanguage),
    });

export const formatDayShort = (date: Date, currentLanguage: LanguageCode) =>
    format(date, 'EEEEEE', {
        locale: mapToDateLocale(currentLanguage),
    });
